module.exports = __webpack_public_path__ + "static/img/2.a8ec5b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/2.png
// module id = FSDn
// module chunks = 0